<template>
  <div class="scene-add">
    <my-header :title="title">
      <template>
        <el-button type="text" class="btn" @click="save">保存</el-button>
      </template>
    </my-header>
    <div class="container">
      <div class="tabMenu">
        <div class="warp">
          <div v-for="(m,i) in menus" :key="`scene_t_${i}`" v-text="m.name" :selected="index===i" @click="index=i">基本信息</div>
        </div>
      </div>
      <div v-show="index===0" class="content">
        <div class="left">
          <el-form :model="scene" :rules="rules" ref="sceneForm" label-width="100px">
            <el-form-item label="场景名称：" prop="name">
              <el-input v-model="scene.name" :disabled="type===2" placeholder="场景名称"></el-input>
            </el-form-item>
            <el-form-item label="场景别名：">
              <el-input v-model="scene.alias" @change="scene.alias = scene.alias.replace(/，/g,',')" placeholder="场景别名，示例：理科,数学"></el-input>
            </el-form-item>
            <el-form-item label="场景描述：" prop="remark">
              <el-input type="textarea" v-model="scene.remark"></el-input>
            </el-form-item>
            <el-form-item label="选择图标：" prop="icon">
              <div class="icons">
                <div v-for="(icon,i) in icons" :key="`icon_${i}`" @click="changeIcon(icon)" :selected="icon.name === scene.icon">
                  <img :src="icon.name === scene.icon?getActiveResource(icon.name):icon.src"/>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="人体感应：" v-if="devices[0] && devices[0]['version'] < 45">
              <el-switch v-model="reaction"></el-switch>
              <label style="margin: 0 7px 0 35px">延迟关灯时间</label>
              <el-input value="0" style="width: 120px" v-model="delay">
                <template slot="append">秒</template>
              </el-input>
            </el-form-item>
            <el-form-item label="恒照度：">
              <el-switch v-model="light" style="margin-right: 20px"></el-switch>
              <el-input value="0" onkeyup="value=value.replace(/[^\d]/g,'')"  style="width: 160px;margin-right: 20px" v-model="alsValue">
                <template slot="append">恒照度值</template>
              </el-input>
              <el-input onkeyup="value=value.replace(/[^\d]/g,'')"  value="0" style="width: 140px" v-model="alsRange">
                <template slot="append">范围</template>
              </el-input>
            </el-form-item>
            <div class="zhu">
             {{devices[0] && devices[0]['version'] >= 45 ? `* 恒照度需要智慧光感硬件设备支持。` : `* 人体感应，人来开灯，人走关灯，实现节能；节能选项需要智慧人感与智慧光感硬件设备支持。` }}
            </div>
          </el-form>
        </div>
        <div class="right">
          <div>
            <span class="title">动作预览</span>
          </div>
          <div class="item" v-for="item in generateRemark" :key="`item_${item.name}`">
            <div class="title" v-text="item.name"></div>
            <div>
              <span class="label" v-show="i!=='name'" v-for="(key,i) in item" v-text="`${key}`" :key="`item_${item.name}_${i}`"></span>
            </div>
          </div>
        </div>
      </div>
      <keep-alive>
        <component :is="componentName" v-show="index!==0" @changeCommand="updateCommand" :command="scene.cmd"></component>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/HeaderTitle'
import { mapState } from 'vuex'
import basic from '@/model/zone'
import BScroll from 'better-scroll'
import resource from '@/model/resource'
import Light from '@/components/customScene/Light'
import Basic from '@/components/customScene/Basic'
import Spotlight from '@/components/customScene/Spotlight'
import Airpure from '@/components/customScene/Airpure'
import Fan from '@/components/customScene/Fan'
import MySwitch from '@/components/customScene/Switch'
import Curtain from '@/components/customScene/Curtain'
import Aircon from '@/components/customScene/Aircon'
import Colorbar from '@/components/customScene/Colorbar'
import Airswitch from '@/components/customScene/Airswitch'
import { Message } from 'element-ui'
import api from '@/model/device'
import scene from '@/model/scene'
import comm from '../../assets/lib/comm'

export default {
  name: 'SceneAdd',
  props: {
    sceneId: {
      type: Number,
      default: 0 // 如果是0 代表为新增
    },
    type: {
      type: Number,
      default: 0 // 用于最后保存时确定是复制还是修改  1 复制 2 修改
    }
  },
  data () {
    const validateName = (rule, value, callback) => {
      const isCheck = !this.sceneId || this.type === 1 || false
      if (isCheck && this.scenes.filter(s => s.name === value).length) {
        return callback(new Error('场景名称已存在'))
      } else {
        callback()
      }
    }
    return {
      title: '自定义场景',
      index: 0,
      componentName: 'basic',
      scene: {
        name: '',
        remark: '',
        icon: '',
        cmd: [],
        type: 2,
        alias: ''
      },
      reaction: false,
      light: false,
      delay: 0,
      nameMapping: {
        basic: '基本信息',
        light: '教室灯',
        airpure: '新风',
        aircon: '空调',
        curtain: '窗帘',
        switch: '智能插座',
        colorbar: '灯带',
        spotlight: '射灯',
        fan: '风扇',
        airswitch: '智慧空开'
      },
      rules: {
        name: [{ required: true, message: '请输入场景名称', trigger: 'blur' },
          { trigger: 'blur', validator: validateName },
          { min: 2, max: 32, message: '长度在 2 到 8 个字符', trigger: 'blur' }],
        remark: [{ min: 0, max: 512, message: '长度在 0 到 512 个字符', trigger: 'blur' }],
        icon: [{ required: true, message: '请选择场景图标', trigger: 'blur' }]
      },
      icons: resource.getResources(),
      convert: [],
      initOK: false,
      alsValue: 65,
      alsRange: 5
    }
  },
  components: {
    MyHeader,
    Light,
    Basic,
    MySwitch,
    Airpure,
    Fan,
    Spotlight,
    Curtain,
    Aircon,
    Airswitch,
    Colorbar
  },
  computed: {
    ...mapState(['zone', 'lights', 'extDevices', 'scenes', 'devices']),
    menus () {
      const menus = ['basic']
      if (this.lights.length) {
        menus.push('light')
      }
      this.extDevices.forEach(e => {
        menus.push(e.name.indexOf('射灯') > -1 ? 'spotlight' : e.devicetype.key)
      })
      return [...new Set(menus)].map(d => {
        return { name: this.nameMapping[d], value: d }
      }).filter(d => d.name)
    },
    tpMapping () {
      const mapping = { 37: '教室灯', 39: '黑板灯' }
      this.extDevices.forEach(ext => {
        mapping[ext.devicetype.type] = this.nameMapping[ext.name.indexOf('射灯') > -1 ? 'spotlight' : ext.devicetype.key]
      })
      return mapping
    },
    generateRemark () {
      // 根据场景的命令，生成可视化的规则
      let view = []
      this.clearConvert()
      this.scene.cmd.forEach(c => {
        view = view.concat(this.resolveText(c))
      })
      this.clearCommand()
      const obj = {}
      // 根据命令进行合并操作
      view.forEach(v => {
        try {
          if (obj[v.name]) {
            Object.assign(obj[v.name], { ...v })
          } else {
            obj[v.name] = { ...v }
          }
        } catch (e) {
          // console.log(JSON.stringify(obj), JSON.stringify(v))
        }
      })
      return this.lights && this.extDevices && Object.keys(obj).map(a => obj[a])
    }
  },
  watch: {
    index () {
      this.componentName = this.menus[this.index].value === 'switch' ? 'my-switch' : this.menus[this.index].value
    },
    scenes () {
      this.initScene()
    }
  },
  async created () {
    // 请求数据，如果不存在的话
    if (!this.zone) {
      await basic.getBasicInfo()
      this.initOK = true
      this.initScene()
    } else {
      this.initOK = true
      this.initScene()
    }

    let that = this
    this.scene.cmd.forEach(c => {
      if (c.hasOwnProperty('PIR')) {
        that.reaction = !!c.PIR
        that.delay = c.value
      } else if (c.hasOwnProperty('ALS')) {
        that.light = !!c.ALS
        that.alsValue = Number(c.value || that.alsValue)
        that.alsRange = Number(c.alsRange || that.alsRange)
      }
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.s = new BScroll('.tabMenu', {
        scrollX: true,
        click: false,
        eventPassthrough: 'vertical'
      })
    })
  },
  methods: {
    clearConvert () {
      this.convert = []
    },
    clearCommand () {
      // 处理复制命令产生的批量命令，将其转为单个命令
      if (this.initOK) {
        this.scene.cmd = this.scene.cmd.filter(c => {
          let exist = false
          this.convert.filter(conv => conv.type === 'del').forEach(conv => {
            if (conv.cmd === c) {
              exist = true
            }
          })
          return !exist
        }).concat(this.convert.filter(c => c.type === 'add').map(c => {
          return { ...c.cmd }
        }))
      }
      this.clearConvert()
    },
    getActiveResource (name) {
      return resource.getActiveResource(name)
    },
    changeIcon (icon) {
      this.scene.icon = icon.name
    },
    resolveText (command) {
      let batchText = []
      // 解析命令前置需要了解当前命令组成，以下为规则
      // 所有命令的构成基础为cmd+nd+动作+固定操作
      // 先判断是否为全部操作或者是同类型批量操作，全部操作nd为255，同类型操作会有tp字段
      if (command.nd === 255) { // 此处即为批量操作，当前仅支持开关，更多属性请使用单节点方式操作
        // 判断是所有设备，还是指定类型设备
        if (command.tp) {
          // 将批量命令转为单个控制命令
          this.convert.push({ type: 'del', cmd: command })
          // 同类型设备的命令，有可能包含多个类型设备，需要遍历逐一解析
          command.tp.forEach(t => {
            // 需要根据tp映射到具体的值
            // 情况分析，如果cmd为1的话说明仅是开关动作，那么可以直接生成新的，否则需要修改nd为指定nd并删除tp字段
            if (command.cmd === 1) {
              this.tpMapping[t] && batchText.push({ name: this.tpMapping[t], state: command.state ? '开启' : '关闭' })
            }
            if (t === 37) { // 全部的灯具？？此处应因为出厂不一致，不太好处理
              this.lights.forEach(light => {
                if (command.cmd === 1) {
                  this.convert.push({ type: 'add', cmd: { deviceId: light.deviceId, cmd: 1, nd: light.nd, state: command.state } })
                } else {
                  const commandCopy = { ...command, nd: light.nd, deviceId: light.deviceId }
                  delete commandCopy.tp
                  this.convert.push({ type: 'add', cmd: commandCopy })
                  batchText.push(Object.assign({ name: light.name }, this.resolveCommand(light, commandCopy, true)))
                }
              })
            } else { // 其他设备
              this.extDevices.forEach(ext => {
                if (ext.devicetype.type === t) {
                  if (command.cmd === 1) {
                    this.convert.push({ type: 'add', cmd: Object.assign(api.generateCommand(ext, command.state ? 'open' : 'close'), { deviceId: ext.deviceId }) })
                  } else {
                    const commandCopy = { ...command, nd: ext.nd, deviceId: ext.deviceId }
                    delete commandCopy.tp
                    this.convert.push({ type: 'add', cmd: commandCopy })
                    batchText = batchText.concat(this.resolveCommand(ext, commandCopy, false))
                  }
                }
              })
            }
          })
        } else {
          // 全部设备的话，当前仅支持state属性，所以非开即关
          batchText.push({ name: '全部设备', state: command.state ? '开启' : '关闭' })
          this.convert.push({ type: 'del', cmd: command })
          this.lights.forEach(light => {
            this.convert.push({ type: 'add', cmd: { deviceId: light.deviceId, cmd: 1, nd: light.nd, state: command.state } })
          })
          this.extDevices.forEach(ext => {
            this.convert.push({ type: 'add', cmd: Object.assign(api.generateCommand(ext, command.state ? 'open' : 'close'), { deviceId: ext.deviceId }) })
          })
        }
      } else { // 单设备操作
        let exist = false
        // 查找到指定的设备 （根据nd），先找灯，再找外部设备即可
        this.lights.forEach(light => {
          if (light.nd === command.nd) {
            if (command.deviceId && command.deviceId !== light.deviceId) {
              return
            }
            if (command.sid && command.sid !== light.sid) {
              return
            }
            exist = true
            // 灯具操作的话，优先解析2，然后尝试解析 1 3 5
            batchText.push(Object.assign({ name: light.name }, this.resolveCommand(light, command, true)))
            command.deviceId = light.deviceId
          }
        })
        this.extDevices.forEach(ext => {
          if (ext.nd === command.nd) {
            if (command.deviceId && command.deviceId !== ext.deviceId) {
              return
            }
            if (command.sid && command.sid !== ext.sid) {
              return
            }
            exist = true
            batchText = batchText.concat(this.resolveCommand(ext, command, false))
            command.deviceId = ext.deviceId
          }
        })
        if (!exist) {
          this.convert.push({ type: 'del', cmd: command })
        }
      }
      return batchText
    },
    resolveAction (name, prop = false) {
      switch (name) {
        case 'open':
          return prop ? { key: 'state', value: 1 } : { state: '开启' }
        case 'close':
          return prop ? { key: 'state', value: 0 } : { state: '关闭' }
        case 'paused':
          return prop ? { key: 'state', value: 2 } : { state: '停止' }
        case 'red':
          return prop ? { key: 'color', value: 'red' } : { state: '开启', color: '红色' }
        case 'green':
          return prop ? { key: 'color', value: name } : { state: '开启', color: '绿色' }
        case 'blue':
          return prop ? { key: 'color', value: name } : { state: '开启', color: '蓝色' }
        case 'yellow':
          return prop ? { key: 'color', value: name } : { state: '开启', color: '黄色' }
        case 'deepskyblue':
          return prop ? { key: 'color', value: name } : { state: '开启', color: '天蓝' }
        case 'deeppink':
          return prop ? { key: 'color', value: name } : { state: '开启', color: '粉紫' }
        case 'white':
          return prop ? { key: 'color', value: name } : { state: '开启', color: '白色' }
        case 'color':
          return prop ? { key: 'color', value: name } : { state: '开启', color: '炫彩' }
        case 'auto':
          return prop ? { key: 'air', value: 0 } : { state: '开启', air: '自动风' }
        case 'high':
          return prop ? { key: 'air', value: 3 } : { state: '开启', air: '高风' }
        case 'low':
          return prop ? { key: 'air', value: 1 } : { state: '开启', air: '低风' }
        case 'medium':
          return prop ? { key: 'air', value: 2 } : { state: '开启', air: '中风' }
        case 'warm':
          return prop ? { key: 'mode', value: 1 } : { state: '开启', mode: '制热' }
        case 'cool':
          return prop ? { key: 'mode', value: 0 } : { state: '开启', mode: '制冷' }
      }
    },
    updateCommand (command, del) {
      // 合并回传回来的命令，主要更新规则根据nd
      // command为需要变更或新增的，del为需要移除的
      this.scene.cmd = this.scene.cmd.map(cmd => {
        // 如果能找到要删除的匹配项
        if (del.filter(d => d.nd === cmd.nd && (cmd.deviceId ? cmd.deviceId === d.deviceId : true) && (cmd.sid ? cmd.sid === d.sid : true)).length) {
          // 需要移除这条命令，先建立标志位，最后统一过滤掉
          return -1
        } else if (command.filter(c => c.nd === cmd.nd && (c.deviceId ? c.deviceId === cmd.deviceId : true) && (c.sid ? c.sid === cmd.sid : true)).length) {
          // 需要更新的，可以直接更新掉，并从命令中移除
          let index = -1
          command.forEach((c, i) => {
            if (c.nd === cmd.nd && (c.deviceId ? c.deviceId === cmd.deviceId : true) && (c.sid ? c.sid === cmd.sid : true)) {
              index = i
            }
          })
          return command.splice(index, 1)[0]
        } else {
          return cmd
        }
      }).filter(c => c !== -1).concat(command)
    },
    initScene () {
      if (this.sceneId) {
        // 找到并赋值
        const exist = this.scenes.filter(s => s.id === parseInt(this.sceneId))
        if (exist.length) {
          this.scene = { ...exist[0], cmd: JSON.parse(exist[0].cmd) }
          if (this.type === 1) {
            this.scene.name += '-复制'
            delete this.scene.id
            // 自定义场景
            this.scene.type = 2
          }
        }
      }
    },
    save () {
      // 收集尚未保存的配置
      this.$hub.$emit('getCommand')
      // 验证配置
      this.$refs.sceneForm.validate((valid) => {
        if (valid) {
          this.updateScene()
        }
      })
    },
    resolveCommand (device, command, light = false) {
      if (light) {
        switch (command.cmd) {
          case 1:
            return { state: command.state ? '开启' : '关闭' }
          case 3:
            return { br: this.zone.advanced === 1 ? `亮度${command.value}%` : '亮度:不支持' }
          case 5:
            return { cct: this.zone.advanced === 1 ? `色温${command.value}K` : '色温:不支持' }
          case 2:
            return { state: command.ring[1] ? '开启' : '关闭', br: this.zone.advanced === 1 ? `亮度${command.ring[2]}%` : '亮度:不支持', cct: this.zone.advanced === 1 ? `色温${command.ring[4] + (command.ring[3] << 8)}K` : '色温:不支持' }
        }
      } else {
        const batch = []
        // 找到匹配项之后，开始解析支持的命令
        const actions = JSON.parse(device.cmd.action)
        // 找到命令中包含的动作
        Object.keys(actions).forEach(name => {
          if (comm.containObject(command, actions[name])) {
            // 包含了指定的动作，那么该动作即为值，可以进行相应的转换
            batch.push({ name: device.name, ...this.resolveAction(name) })
          }
        })
        if (command.pl && command.pl.tt) {
          batch.push({ name: device.name, tt: `${command.pl.tt}℃` })
        }
        return batch
      }
    },
    async updateScene () {
      // 判断是否有选择设备
      if (!this.scene.cmd.length) {
        Message.warning('场景至少包含一个设备控制')
      } else {
        let deviceid = this.scene.cmd[0].deviceId
        this.scene.cmd.push({ PIR: this.reaction ? 1 : 0, value: parseInt(this.delay), deviceId: deviceid })
        this.scene.cmd.push({ ALS: this.light ? 1 : 0, value: this.alsValue, alsRange: this.alsRange, deviceId: deviceid })
        if (this.light && (this.alsValue === '' || this.alsRange === '')) {
          Message.error('恒照度亮度和范围不能为空')
          return
        }
        if (this.scene.id) {
          // 修改
          const loading = comm.showLoading()
          try {
            await scene.edit(this.zone.id, this.scene)
            // 刷新场景
            await scene.load(this.zone.id)
            Message.success('场景修改成功')
            this.$router.push('/scene')
          } finally {
            comm.closeLoading(loading)
          }
        } else {
          // 新增
          const loading = comm.showLoading()
          try {
            await scene.add(this.zone.id, this.scene)
            // 刷新场景
            await scene.load(this.zone.id)
            Message.success('场景添加成功')
            this.$router.push('/scene')
          } finally {
            comm.closeLoading(loading)
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
.scene-add {
  height: 100%;
  display: flex;
  flex-direction: column;
  .btn {
    font-size: 17px;
    font-weight: 500;
    color: rgba(58, 212, 116, 1);
  }
  .container {
    flex: 1;
    position: relative;
    padding: 45px 20px 20px 20px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    > .tabMenu {
      position: relative;
      height: 60px;
      margin-top: 20px;
      border-radius: 4px;
      background-color: white;
      overflow: hidden;
      padding: 0px 24px;
      width: 100%;
      flex: 0 0 auto;
      & .warp {
        overflow: hidden;
        position: absolute;
        white-space: nowrap;
        > div:first-child {
          margin-left: 0px
        }
        > div:last-child {
          margin-right: 0px
        }
        > div {
          padding: 22px 0px;
          margin: 0px 28px;
          height: 100%;
          display: inline-block;
          font-size: 16px;
          font-weight: 600;
          height: 60px;
          color: rgba(34, 34, 34, 1);
          cursor: pointer;
        }
        > div[selected] {
          color: #3AD474;
          border-bottom: 2px solid #3AD474;
        }
      }
    }
    > .content {
      margin-top: 20px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      flex: 1;
      height: 0;
      display: flex;
      flex-direction: row;
      padding: 30px 20px;
      > .left {
        flex: 1;
        padding-right: 40px;
        width: 0;
        & .zhu {
          text-align: left;
          padding-left: 15px;
          color: #f56c6c;
          font-size: 12px;
        }
      }
      > .right {
        overflow-y: auto;
        padding-left: 20px;
        width: 300px;
        border-left: 1px solid #DFE1E5;
        & .title {
          font-size: 17px;
          font-weight: 600;
          color: rgba(89, 89, 89, 1);
        }
        & .item {
          & .title {
            margin-top: 20px;
            font-size: 15px;
            font-weight: 600;
            color: rgba(89, 89, 89, 1);
          }
          & .label {
            margin-top: 10px;
            border: 1px solid rgba(165, 176, 194, 1);
            opacity: 0.6;
            font-size: 14px;
            border-radius: 2px;
            display: inline-block;
            padding: 2px 5px;
            margin-right: 20px;
          }
        }
      }
    }
    .icons {
      display: flex;
      flex-wrap: wrap;
      padding-top: -10px;
      > div {
        width: 55px;
        height: 55px;
        border: 2px solid rgba(216, 228, 247, 1);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 35px;
        cursor: pointer;
        margin-top: 10px;
      }
      > div[selected] {
        background-color: #47CC6B;
        border: 0;
      }
      & img {
        width: 27px;
      }
    }
    > .scene_add {
      height:90%;
    }
  }
}
</style>
